import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import building from './building.png';
import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import {
  REVIEW_TYPE_OF_PROVIDER,
  REVIEW_TYPE_OF_CUSTOMER,
  SCHEMA_TYPE_MULTI_ENUM,
  SCHEMA_TYPE_TEXT,
  SCHEMA_TYPE_YOUTUBE,
  propTypes,
} from '../../util/types';
import {
  NO_ACCESS_PAGE_USER_PENDING_APPROVAL,
  NO_ACCESS_PAGE_VIEW_LISTINGS,
  PROFILE_PAGE_PENDING_APPROVAL_VARIANT,
} from '../../util/urlHelpers';
import {
  isErrorNoViewingPermission,
  isErrorUserPendingApproval,
  isForbiddenError,
  isNotFoundError,
} from '../../util/errors';
import { pickCustomFieldProps } from '../../util/fieldHelpers';
import {
  getCurrentUserTypeRoles,
  hasPermissionToViewData,
  isUserAuthorized,
} from '../../util/userHelpers';
import { richText } from '../../util/richText';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  Heading,
  H2,
  H4,
  Page,
  AvatarLarge,
  NamedLink,
  ListingCard,
  Reviews,
  ReviewRating,
  ButtonTabNavHorizontal,
  LayoutSingleColumn,
  LayoutSideNavigation,
  NamedRedirect,
  IconLocation,
  IconDate,
  IconInquiry,
  IconSearch,
  ResponsiveImage,
} from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';


import { createVisitListing } from './ProfilePage.duck';

import css from './ProfilePage.module.css';
import SectionDetailsMaybe from './SectionDetailsMaybe';
import SectionTextMaybe from './SectionTextMaybe';
import SectionMultiEnumMaybe from './SectionMultiEnumMaybe';
import SectionYoutubeVideoMaybe from './SectionYoutubeVideoMaybe';
import SectionFarmerProfile from './SectionFarmerProfile';
import SectionConsumerProfile from './SectionConsumerProfile';
import SectionCollaboratorProfile from './SectionCollaboratorProfile';
const MAX_MOBILE_SCREEN_WIDTH = 768;
const MIN_LENGTH_FOR_LONG_WORDS = 20;

export const AsideContent = props => {
  const { user, displayName, showLinkToProfileSettingsPage } = props;
  return (
    <div className={css.asideContent}>
      <AvatarLarge className={css.avatar} user={user} disableProfileLink />
      <H2 as="h1" className={css.mobileHeading}>
        {displayName ? (
          <FormattedMessage id="ProfilePage.mobileHeading" values={{ name: displayName }} />
        ) : null}
      </H2>
      {showLinkToProfileSettingsPage ? (
        <>
          <NamedLink className={css.editLinkMobile} name="ProfileSettingsPage">
            <FormattedMessage id="ProfilePage.editProfileLinkMobile" />
          </NamedLink>
          <NamedLink className={css.editLinkDesktop} name="ProfileSettingsPage">
            <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
          </NamedLink>
        </>
      ) : null}
    </div>
  );
};

export const ReviewsErrorMaybe = props => {
  const { queryReviewsError } = props;
  return queryReviewsError ? (
    <p className={css.error}>
      <FormattedMessage id="ProfilePage.loadingReviewsFailed" />
    </p>
  ) : null;
};

export const MobileReviews = props => {
  const { reviews, queryReviewsError } = props;
  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  return (
    <div className={css.mobileReviews}>
      <H4 as="h2" className={css.mobileReviewsTitle}>
        <FormattedMessage
          id="ProfilePage.reviewsFromMyCustomersTitle"
          values={{ count: reviewsOfProvider.length }}
        />
      </H4>
      <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />
      <Reviews reviews={reviewsOfProvider} />
      <H4 as="h2" className={css.mobileReviewsTitle}>
        <FormattedMessage
          id="ProfilePage.reviewsAsACustomerTitleRecipes"
          values={{ count: reviewsOfCustomer.length }}
        />
      </H4>
      <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />
      <Reviews reviews={reviewsOfCustomer} />
    </div>
  );
};

export const DesktopReviews = props => {
  const { reviews, queryReviewsError, userTypeRoles, intl } = props;
  const { customer: isCustomerUserType, provider: isProviderUserType } = userTypeRoles;

  const initialReviewState = !isProviderUserType
    ? REVIEW_TYPE_OF_CUSTOMER
    : REVIEW_TYPE_OF_PROVIDER;
  const [showReviewsType, setShowReviewsType] = useState(initialReviewState);

  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  const isReviewTypeProviderSelected = showReviewsType === REVIEW_TYPE_OF_PROVIDER;
  const isReviewTypeCustomerSelected = showReviewsType === REVIEW_TYPE_OF_CUSTOMER;
  const providerReviewsMaybe = isProviderUserType
    ? [
      {
        text: (
          <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
            <FormattedMessage
              id="ProfilePage.reviewsFromMyCustomersTitle"
              values={{ count: reviewsOfProvider.length }}
            />
          </Heading>
        ),
        selected: isReviewTypeProviderSelected,
        onClick: () => setShowReviewsType(REVIEW_TYPE_OF_PROVIDER),
      },
    ]
    : [];

  const customerReviewsMaybe = isCustomerUserType
    ? [
      {
        text: (
          <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
            <FormattedMessage
              id="ProfilePage.reviewsAsACustomerTitleRecipes"
              values={{ count: reviewsOfCustomer.length }}
            />
          </Heading>
        ),
        selected: isReviewTypeCustomerSelected,
        onClick: () => setShowReviewsType(REVIEW_TYPE_OF_CUSTOMER),
      },
    ]
    : [];
  const desktopReviewTabs = [...providerReviewsMaybe, ...customerReviewsMaybe];

  return (
    <div className={css.desktopReviews}>
      <div className={css.desktopReviewsWrapper}>
        <ButtonTabNavHorizontal
          className={css.desktopReviewsTabNav}
          tabs={desktopReviewTabs}
          ariaLabel={intl.formatMessage({ id: 'ProfilePage.screenreader.reviewsNav' })}
        />

        <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />

        {isReviewTypeProviderSelected ? (
          <Reviews reviews={reviewsOfProvider} />
        ) : (
          <Reviews reviews={reviewsOfCustomer} />
        )}
      </div>
    </div>
  );
};

export const CustomUserFields = props => {
  const { publicData, metadata, userFieldConfig } = props;

  const shouldPickUserField = fieldConfig =>
    fieldConfig?.scope === 'public' && fieldConfig?.showConfig?.displayInProfile !== false;
  const propsForCustomFields =
    pickCustomFieldProps(publicData, metadata, userFieldConfig, 'userType', shouldPickUserField) ||
    [];

  return (
    <>
      <SectionDetailsMaybe {...props} />
      {propsForCustomFields.map(customFieldProps => {
        const { schemaType, key, ...fieldProps } = customFieldProps;
        return schemaType === SCHEMA_TYPE_MULTI_ENUM ? (
          <SectionMultiEnumMaybe key={key} {...fieldProps} />
        ) : schemaType === SCHEMA_TYPE_TEXT ? (
          <SectionTextMaybe key={key} {...fieldProps} />
        ) : schemaType === SCHEMA_TYPE_YOUTUBE ? (
          <SectionYoutubeVideoMaybe key={key} {...fieldProps} />
        ) : null;
      })}
    </>
  );
};

export const MainContent = props => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const {
    userShowError,
    bio,
    displayName,
    listings,
    queryListingsError,
    reviews = [],
    queryReviewsError,
    publicData,
    metadata,
    userFieldConfig,
    intl,
    hideReviews,
    userTypeRoles,

    user,
  } = props;
  console.log('user', user);
  const { currentUser } = useSelector(state => state?.user);
  const isCurrentUser = currentUser?.id && user?.id && currentUser.id.uuid === user.id.uuid;
  const userType = publicData?.userType || publicData?.user_type;
  const isFarmerProfile = userType === 'farmer';
  const dispatch = useDispatch();
  const history = useHistory();
  const [isInProgress, setIsInProgress] = useState(false);
  const hasListings = listings.length > 0;
  const hasMatchMedia = typeof window !== 'undefined' && window?.matchMedia;
  const isMobileLayout =
    mounted && hasMatchMedia
      ? window.matchMedia(`(max-width: ${MAX_MOBILE_SCREEN_WIDTH}px)`)?.matches
      : true;

  const hasBio = !!bio;
  const bioWithLinks = richText(bio, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
  });

  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const totalRatings = reviewsOfProvider.reduce((acc, r) => acc + r.attributes.rating, 0);
  const averageRating =
    reviewsOfProvider.length > 0 ? (totalRatings / reviewsOfProvider.length).toFixed(1) : null;

  const locationString =
    publicData?.address?.selectedPlace?.address ||
    currentUser?.attributes?.profile?.publicData?.address?.search ||
    publicData?.location ||
    intl.formatMessage({ id: 'ProfilePage.noLocationSet' });
  const farmName = publicData?.farmName || displayName;
  const slogan = publicData?.farmDescription || bio;
  const profileImage = user?.profileImage;

  const productsRaw = publicData?.availableProducts;
  const productList = Array.isArray(productsRaw)
    ? productsRaw
    : typeof productsRaw === 'string'
      ? productsRaw.split(',').map(p => p.trim())
      : [];
  const finalProductList = productList.filter(p => p && p.length > 0);

  const visitListing = listings.find(l => {
    const listingId = l.id?.uuid || l.id;
    const automaticVisitId =
      publicData?.automaticVisitId ||
      currentUser?.attributes?.profile?.publicData?.automaticVisitId;
    const isMatchingId =
      automaticVisitId && (listingId === automaticVisitId || listingId?.uuid === automaticVisitId);
    const isVisitType =
      l.attributes?.publicData?.listingType === 'visit' ||
      l.attributes?.publicData?.listing_type === 'visit' ||
      l.attributes?.publicData?.productType === 'visit' ||
      l.attributes?.publicData?.product_type === 'visit';
    return isMatchingId || isVisitType;
  });
  const handleBuyVisitClick = async () => {
    const profilePublicData = user?.attributes?.profile?.publicData;
    const automaticVisitId = profilePublicData?.automaticVisitId;

    if (automaticVisitId) {
      history.push(`/l/visit/${automaticVisitId}`);
    } else if (isFarmerProfile) {
      if (isInProgress) return;
      setIsInProgress(true);
      dispatch(createVisitListing(user))
        .unwrap()
        .then(newListing => {
          setIsInProgress(false);
          redirectToCheckout(newListing);
        })
        .catch(e => {
          setIsInProgress(false);
          console.error(e);
        });
    }
  };

  if (userShowError || queryListingsError) {
    return (
      <p className={css.error}>
        <FormattedMessage id="ProfilePage.loadingDataFailed" />
      </p>
    );
  }

  // Define icons or use emojis if icons are missing
  const LocationIcon = () => <IconLocation className={css.infoIcon} />;
  const CalendarIcon = () => <IconDate className={css.infoIcon} />;
  const ContactIcon = () => <IconInquiry className={css.infoIcon} />;
  const SearchIcon = () => <IconSearch className={css.infoIcon} />;

  // Check if this is a farmer profile

  // Render farmer-specific layout
  if (isFarmerProfile) {
    return (
      <div className={css.container}>
        {/* 1. Header Section */}
        <div className={css.profilePageHeader}>
          <h1 className={css.profilePageTitle}>{farmName}</h1>
          <div className={css.headerLocation}>
            <IconLocation className={css.headerLocationIcon} />
            <span>{locationString}</span>
          </div>
          {slogan && <p className={css.profilePageSubtitle}>{slogan}</p>}
        </div>

        {/* 2. Profile Card Section */}
        <div className={css.profileCard}>
          <div className={css.profileLeft}>
            <div className={css.imageWrapper}>
              {profileImage ? (
                <ResponsiveImage
                  rootClassName={css.profileAvatar}
                  image={profileImage}
                  variants={['square-small', 'square-small2x']}
                  alt={displayName}
                />
              ) : (
                <AvatarLarge user={user} className={css.profileAvatar} disableProfileLink />
              )}
              {publicData?.isVarified && (
                <div className={css.certifiedBadgeTopRight}>
                  <span className={css.certifiedIcon}>✓</span>
                  <FormattedMessage id="ProfilePage.certified" />
                  {/* {publicData?.certificateInfo && (
                  <span className={css.certificateInfo}> - {publicData.certificateInfo}</span>
                )} */}
                </div>
              )}
            </div>

            {hasBio ? (
              <div className={css.bioSection}>
                <h4 className={css.bioTitle}>
                  <FormattedMessage id="ProfilePage.aboutMeTitle" />
                </h4>
                <p className={css.bio}>{bioWithLinks}</p>
              </div>
            ) : null}
          </div>

          <div className={css.profileRight}>
            <div className={css.infoBox}>
              {/* Row 1: Location & Follow */}
              <div className={css.infoRow}>
                <div className={css.locationWrapper}>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <LocationIcon />
                    <span>{locationString}</span>
                  </div>
                  <button className={css.followButton}>
                    <FormattedMessage id="ProfilePage.followButton" />
                  </button>
                </div>
              </div>

              {/* Row 2: Popular/Products */}
              <div className={css.infoRow}>
                <SearchIcon />
                <div className={css.infoContent}>
                  <span className={css.rowLabel}>
                    <FormattedMessage id="ProfilePage.popularProducts" />
                  </span>
                  {finalProductList.length > 0 ? (
                    <ul className={css.productList}>
                      {finalProductList.slice(0, 5).map((p, i) => (
                        <li key={i}>{p}</li>
                      ))}
                    </ul>
                  ) : (
                    <span>-</span>
                  )}
                </div>
              </div>

              {/* Row 3: Pickup info */}
              <div className={css.infoRow}>
                <CalendarIcon />
                <div className={css.infoContent}>
                  <span>
                    {publicData?.sameDayPickup ? (
                      <FormattedMessage id="ProfilePage.sameDayPickupAvailable" />
                    ) : (
                      <FormattedMessage id="ProfilePage.pickupScheduled" />
                    )}
                  </span>
                </div>
              </div>

              {/* Row 4: Contact & Buy Visit */}
              <div className={css.infoRow}>
                <div className={css.contactAndVisit}>
                  <div className={css.contactSection}>
                    <img src={building} alt="Contact" className={css.contactIcon} />
                    <div className={css.infoContent}>
                      <span style={{ cursor: 'pointer', color: '#2c5234' }}>
                        <FormattedMessage id="ProfilePage.contactLink" />
                      </span>
                    </div>
                  </div>
                  {isFarmerProfile && (
                    <div className={css.visitSection}>
                      <button
                        className={css.buyVisitButton}
                        onClick={handleBuyVisitClick}
                        disabled={isInProgress}
                      >
                        {isInProgress ? (
                          <FormattedMessage id="ProfilePage.creatingListing" />
                        ) : (
                          <FormattedMessage id="ProfilePage.buyVisit" />
                        )}
                        {(publicData?.visitPriceType || (!visitListing && isCurrentUser)) &&
                          !isInProgress && (
                            <span className={css.visitPrice}>
                              {publicData?.visitPriceType === '5euro' || !visitListing
                                ? '5€'
                                : publicData.visitPriceType}
                            </span>
                          )}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Rating Section */}
              {averageRating && (
                <div className={css.ratingSection}>
                  <div className={css.ratingRow}>
                    <ReviewRating rating={parseFloat(averageRating)} />
                    <span className={css.ratingText}>{averageRating.replace('.', ',')} de 5</span>
                  </div>
                  <span className={css.reviewsCount}>
                    (
                    {intl.formatMessage(
                      { id: 'ProfilePage.reviewCount' },
                      { count: reviewsOfProvider.length }
                    )}
                    )
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={css.listingsContainer}>
          {hasListings ? (
            <>
              <H4 as="h2" className={css.listingsTitle}>
                <FormattedMessage
                  id="ProfilePage.listingsTitle"
                  values={{ count: listings.length }}
                />
              </H4>
              <ul className={css.listings}>
                {listings.map(l => (
                  <li className={css.listing} key={l.id.uuid}>
                    <ListingCard listing={l} showAuthorInfo={false} />
                  </li>
                ))}
              </ul>
            </>
          ) : null}
        </div>

        {hideReviews ? null : isMobileLayout ? (
          <MobileReviews
            reviews={reviews}
            queryReviewsError={queryReviewsError}
            userTypeRoles={userTypeRoles}
          />
        ) : (
          <DesktopReviews
            reviews={reviews}
            queryReviewsError={queryReviewsError}
            userTypeRoles={userTypeRoles}
            intl={intl}
          />
        )}
      </div>
    );
  }

  // Render default/simple layout for non-farmers (old layout)
  const listingsContainerClasses = classNames(css.listingsContainer, {
    [css.withBioMissingAbove]: !hasBio,
  });

  return (
    <div>
      <H2 as="h1" className={css.desktopHeading}>
        <FormattedMessage id="ProfilePage.desktopHeading" values={{ name: displayName }} />
      </H2>
      {hasBio ? <p className={css.bio}>{bioWithLinks}</p> : null}

      {displayName ? (
        <>
          <CustomUserFields
            publicData={publicData}
            metadata={metadata}
            userFieldConfig={userFieldConfig}
            intl={intl}
          />

          {/* Role-specific profile sections */}
          <SectionFarmerProfile publicData={publicData} metadata={metadata} intl={intl} />
          <SectionConsumerProfile
            publicData={publicData}
            metadata={metadata}
            listings={listings}
            intl={intl}
          />
          <SectionCollaboratorProfile publicData={publicData} metadata={metadata} intl={intl} />
        </>
      ) : null}

      {hasListings ? (
        <div className={listingsContainerClasses}>
          <H4 as="h2" className={css.listingsTitle}>
            <FormattedMessage id="ProfilePage.listingsTitle" values={{ count: listings.length }} />
          </H4>
          <ul className={css.listings}>
            {listings.map(l => (
              <li className={css.listing} key={l.id.uuid}>
                <ListingCard listing={l} showAuthorInfo={false} />
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {hideReviews ? null : isMobileLayout ? (
        <MobileReviews
          reviews={reviews}
          queryReviewsError={queryReviewsError}
          userTypeRoles={userTypeRoles}
        />
      ) : (
        <DesktopReviews
          reviews={reviews}
          queryReviewsError={queryReviewsError}
          userTypeRoles={userTypeRoles}
          intl={intl}
        />
      )}
    </div>
  );
};

/**
 * ProfilePageComponent
 *
 * @component
 * @param {Object} props
 * @param {boolean} props.scrollingDisabled - Whether the scrolling is disabled
 * @param {propTypes.currentUser} props.currentUser - The current user
 * @param {boolean} props.useCurrentUser - Whether to use the current user
 * @param {propTypes.user|propTypes.currentUser} props.user - The user
 * @param {propTypes.error} props.userShowError - The user show error
 * @param {propTypes.error} props.queryListingsError - The query listings error
 * @param {Array<propTypes.listing|propTypes.ownListing>} props.listings - The listings
 * @param {Array<propTypes.review>} props.reviews - The reviews
 * @param {propTypes.error} props.queryReviewsError - The query reviews error
 * @returns {JSX.Element} ProfilePageComponent
 */
export const ProfilePageComponent = props => {
  const config = useConfiguration();
  const intl = useIntl();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const {
    scrollingDisabled,
    params: pathParams,
    currentUser,
    useCurrentUser,
    userShowError,
    user,
    ...rest
  } = props;
  const isVariant = pathParams.variant?.length > 0;
  const isPreview = isVariant && pathParams.variant === PROFILE_PAGE_PENDING_APPROVAL_VARIANT;

  // Stripe's onboarding needs a business URL for each seller, but the profile page can be
  // too empty for the provider at the time they are creating their first listing.
  // To remedy the situation, we redirect Stripe's crawler to the landing page of the marketplace.
  // TODO: When there's more content on the profile page, we should consider by-passing this redirection.
  const searchParams = rest?.location?.search;
  const isStorefront = searchParams
    ? new URLSearchParams(searchParams)?.get('mode') === 'storefront'
    : false;
  if (isStorefront) {
    return <NamedRedirect name="LandingPage" />;
  }

  const isCurrentUser = currentUser?.id && currentUser?.id?.uuid === pathParams.id;
  const profileUser = useCurrentUser ? currentUser : user;
  const { bio, displayName, publicData, metadata } = profileUser?.attributes?.profile || {};
  const { userFields } = config.user;
  const isPrivateMarketplace = config.accessControl.marketplace.private === true;
  const isUnauthorizedUser = currentUser && !isUserAuthorized(currentUser);
  const isUnauthorizedOnPrivateMarketplace = isPrivateMarketplace && isUnauthorizedUser;
  const hasUserPendingApprovalError = currentUser?.attributes?.state === "pendingApproval" || isErrorUserPendingApproval(userShowError);
  const hasNoViewingRightsUser = currentUser && !hasPermissionToViewData(currentUser);
  const hasNoViewingRightsOnPrivateMarketplace = isPrivateMarketplace && hasNoViewingRightsUser;

  const userTypeRoles = getCurrentUserTypeRoles(config, profileUser);

  const isDataLoaded =
    isPreview || isCurrentUser
      ? currentUser != null || userShowError != null
      : hasNoViewingRightsOnPrivateMarketplace
        ? currentUser != null || userShowError != null
        : user != null || userShowError != null;

  const schemaTitleVars = { name: displayName, marketplaceName: config.marketplaceName };
  const schemaTitle = intl.formatMessage({ id: 'ProfilePage.schemaTitle' }, schemaTitleVars);

  if (!isDataLoaded) {
    return null;
  } else if (!isPreview && isNotFoundError(userShowError)) {
    return <NotFoundPage staticContext={props.staticContext} />;
  } else if (
    !isPreview &&
    (isUnauthorizedOnPrivateMarketplace || hasUserPendingApprovalError)
    // && !isCurrentUser
  ) {
    return (
      <NamedRedirect
        name="NoAccessPage"
        params={{ missingAccessRight: NO_ACCESS_PAGE_USER_PENDING_APPROVAL }}
      />
    );
  } else if (
    ((!isPreview && hasNoViewingRightsOnPrivateMarketplace) ||
      isErrorNoViewingPermission(userShowError)) &&
    !isCurrentUser
  ) {
    // Someone without viewing rights on a private marketplace is trying to
    // view a profile page that is not their own – redirect to NoAccessPage
    return (
      <NamedRedirect
        name="NoAccessPage"
        params={{ missingAccessRight: NO_ACCESS_PAGE_VIEW_LISTINGS }}
      />
    );
  } else if (!isPreview && isForbiddenError(userShowError)) {
    // This can happen if private marketplace mode is active, but it's not reflected through asset yet.
    return (
      <NamedRedirect
        name="SignupPage"
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  } else if (isPreview && mounted && !isCurrentUser) {
    // Someone is manipulating the URL, redirect to current user's profile page.
    return isCurrentUser === false ? (
      <NamedRedirect name="ProfilePage" params={{ id: currentUser?.id?.uuid }} />
    ) : null;
  } else if ((isPreview || isPrivateMarketplace) && !mounted) {
    // This preview of the profile page is not rendered on server-side
    // and the first pass on client-side should render the same UI.
    return null;
  }

  // Check if this is a farmer profile for layout decision
  const userType = publicData?.userType || publicData?.user_type;
  const isFarmerProfile = userType === 'farmer';

  // This is rendering normal profile page (not preview for pending-approval)
  // Use different layouts based on user type
  if (isFarmerProfile) {
    // Farmer profile - use single column layout with new design
    return (
      <Page
        scrollingDisabled={scrollingDisabled}
        title={schemaTitle}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'ProfilePage',
          mainEntity: {
            '@type': 'Person',
            name: profileUser?.attributes?.profile?.displayName,
          },
          name: schemaTitle,
        }}
      >
        <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
          <MainContent
            bio={bio}
            displayName={displayName}
            userShowError={userShowError}
            publicData={publicData}
            metadata={metadata}
            userFieldConfig={userFields}
            hideReviews={hasNoViewingRightsOnPrivateMarketplace}
            intl={intl}
            userTypeRoles={userTypeRoles}
            user={profileUser}
            {...rest}
          />
        </LayoutSingleColumn>
      </Page>
    );
  }

  // Non-farmer profile - use side navigation layout with old design
  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ProfilePage',
        mainEntity: {
          '@type': 'Person',
          name: profileUser?.attributes?.profile?.displayName,
        },
        name: schemaTitle,
      }}
    >
      <LayoutSideNavigation
        sideNavClassName={css.aside}
        topbar={<TopbarContainer />}
        sideNav={
          <AsideContent
            user={profileUser}
            showLinkToProfileSettingsPage={mounted && isCurrentUser}
            displayName={displayName}
          />
        }
        footer={<FooterContainer />}
      >
        <MainContent
          bio={bio}
          displayName={displayName}
          userShowError={userShowError}
          publicData={publicData}
          metadata={metadata}
          userFieldConfig={userFields}
          hideReviews={hasNoViewingRightsOnPrivateMarketplace}
          intl={intl}
          userTypeRoles={userTypeRoles}
          user={profileUser}
          {...rest}
        />
      </LayoutSideNavigation>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    userId,
    userShowError,
    queryListingsError,
    userListingRefs,
    reviews = [],
    queryReviewsError,
  } = state.ProfilePage;
  const userMatches = getMarketplaceEntities(state, [{ type: 'user', id: userId }]);
  const user = userMatches.length === 1 ? userMatches[0] : null;

  // Show currentUser's data if it's not approved yet
  const isCurrentUser = userId?.uuid === currentUser?.id?.uuid;
  const useCurrentUser =
    isCurrentUser && !(isUserAuthorized(currentUser) && hasPermissionToViewData(currentUser));

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    useCurrentUser,
    user,
    userShowError,
    queryListingsError,
    listings: getMarketplaceEntities(state, userListingRefs),
    reviews,
    queryReviewsError,
  };
};

const ProfilePage = compose(connect(mapStateToProps))(ProfilePageComponent);

export default ProfilePage;
